import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component FolderMoveIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <FolderMoveIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <FolderMoveIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const FolderMoveIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="FolderMoveIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m10 4 2 2h8a2 2 0 0 1 1.995 1.851L22 8v10c0 1.06-.81 1.919-1.85 1.995L20 20H4a2 2 0 0 1-1.994-1.85L2 18V6a2 2 0 0 1 1.851-1.995L4 4zm10 4H4v10h16zm-10 2 4 3-4 3v-2H6v-2h4z"
      />
    </svg>
  )
);
FolderMoveIcon.displayName = "FolderMoveIcon";
export default FolderMoveIcon;
